export function isAgentV2(agentId?: string | null) {
    return agentId ? agentId.startsWith('v2_') : false;
}

export function useAgentIsV2(agentId?: string) {
    if (!!agentId) {
        return isAgentV2(agentId);
    }

    return true;
}
